import { IObservableArray, makeAutoObservable, observable } from "mobx";
import { GroupWithStudentsAndModulesResponseApi } from "../DTO/ServerResponseType/Group/Group";
import UserServerClient from "../ServerClients/UserServerClient";
import { GroupLearningPathResponseApi } from "../DTO/ServerResponseType/Group/GroupLearningPath";

export class GroupsStore {
  groups: IObservableArray<GroupWithStudentsAndModulesResponseApi> =
    observable.array([]);
  groupLearningPaths: IObservableArray<GroupLearningPathResponseApi> =
    observable.array([]);
  showGroupList: boolean = true;
  showGroupLearningPathList: boolean = true;
  constructor() {
    makeAutoObservable(this);
  }

  setGroups = (groups: GroupWithStudentsAndModulesResponseApi[]) => {
    this.groups = observable.array(groups);
  };

  setGroupLearningPaths = (
    groupLearningPaths: GroupLearningPathResponseApi[]
  ) => {
    this.groupLearningPaths = observable.array(groupLearningPaths);
  };

  onChangeShowGroupList = (showGroupList: boolean) => {
    this.showGroupList = showGroupList;
  };
  onChangeShowGroupLearningPathList = (showGroupLearningPathList: boolean) => {
    this.showGroupLearningPathList = showGroupLearningPathList;
  };

  loadAllGroupsAsync = async (): Promise<
    GroupWithStudentsAndModulesResponseApi[] | never
  > => {
    return UserServerClient.sendToGetUserWithGroupsAsync().then(
      ({ userGroups, userGroupLearningPaths }) => {
        this.setGroups(userGroups);
        this.setGroupLearningPaths(userGroupLearningPaths);
        return userGroups;
      }
    );
  };
}
